
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-all",
      function () {
        return require("private-next-pages/view-all/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-all"])
      });
    }
  